export default __webpack_public_path__ + "assets/53efd9.svg";